const $body = document.querySelector("body");
const $header = document.querySelector("header");
const $headerLinks = document.querySelector(".header-links");
let scrollPosition = 0;

/**
 * @function
 * @description - Enable page scroll lock
 */
const enable = (isQuickView = false) => {
    if (!isEnabled()) {
        enabledStickyElemScroll();

        scrollPosition = window.scrollY;
        const isMobileStickyHeader = (window.mqRespond.status.mobile || window.mqRespond.status.tablet) && scrollPosition > 0;

        if (isQuickView) {
            $body.style.position = "relative";
        } else {
            $body.style.top = isMobileStickyHeader ? `-${scrollPosition - $header.offsetHeight}px` : `-${scrollPosition}px`;
            $body.style.position = "fixed";
        }

        $body.style.width = "100%";
        $header.style.top = isMobileStickyHeader ? `${scrollPosition - $header.offsetHeight}px` : "auto";
        $header.style.position = isMobileStickyHeader ? "absolute" : "relative";

        if ($headerLinks) {
            $headerLinks.style.display = isMobileStickyHeader ? "none" : "";
        }
    }
};

/**
 * @function
 * @description - Disable page scroll lock
 * @param {Boolean} noScroll - Do not scroll automatically to a given position
 */
const disable = noScroll => {
    handleActiveVeil();
    disabledStickyElemScroll();

    $body.style.removeProperty("position");
    $body.style.removeProperty("top");
    $body.style.removeProperty("width");
    $header.style.removeProperty("top");
    $header.style.removeProperty("position");

    if ($headerLinks) {
        $headerLinks.style.removeProperty("display");
    }

    if (!noScroll) {
        window.scrollTo(0, scrollPosition);
    }
};

/**
 * @function
 * @description - Returns page scroll lock status
 */
const isEnabled = () => { return $body.style.position === "fixed"; };

/**
 * @function
 * @description - Fixes veil functionality if it was opened before disabling the scroll lock;
 * "fixed" position not being removed before adding veil, makes it skip some logic from spinner.js
 */
const handleActiveVeil = () => {
    const $veil = $body.querySelectorAll(".veil")[0];
    if ($veil && $veil.parentNode !== $body) {
        return;
    }

    $body.parentNode.style.position = "relative";
    $body.parentNode.classList.add("veiled");
};

/**
 * @function
 * @description - Add padding-right as on body element on sticky elements when modal is open
 */
const enabledStickyElemScroll = () => {
    const isStickyFull = document.querySelectorAll(".js-sticky-element--full-width.is-sticky");

    if (!isStickyFull.length) {
        return;
    }

    const bodyPaddingRight = document.body.style.paddingRight;
    isStickyFull.forEach(elem => {
        elem.style.paddingRight = bodyPaddingRight;
    });
};

/**
 * @function
 * @description - Remove padding-right from sticky elements after a modal is closed
 */
const disabledStickyElemScroll = () => {
    const isStickyFull = document.querySelectorAll(".js-sticky-element--full-width.is-sticky");

    if (!isStickyFull.length) {
        return;
    }

    isStickyFull.forEach(elem => {
        elem.style.removeProperty("padding-right");
    });
};

module.exports = {
    enable: enable,
    disable: disable,
    isEnabled: isEnabled
};
